//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SavedTime",
  props: {
    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    showMore: false
  }),

  computed: {
    total() {
      return this.left + this.right;
    }
  }
}
